import {
  CpsiAccessRequestView,
  HstAccessRequestView,
  FacilityMaintenanceRequestView,
  PreventiveMaintenanceRequestView,
  CostRecordView,
  CustomApplicationRequestView,
  ReportingRequestView,
} from './accessRequestTypes';

/**
 * Shared default factory functions for request sub-entities.
 * Used by both ticketSlice and recurringTaskSlice to avoid duplicating defaults.
 */

export const createDefaultCpsiAccessRequest = (): CpsiAccessRequestView => ({
  id: '',
  user: '',
  center: '',
  copyPermissionsFrom: ''
});

export const createDefaultHstAccessRequest = (): HstAccessRequestView => ({
  id: '',
  user: '',
  role: '',
  centers: []
});

export const createDefaultFacilityMaintenanceRequest = (): FacilityMaintenanceRequestView => ({
  id: '',
  center: '',
  title: '',
  description: '',
  locationDetail: '',
  issueType: '',
  repairableBy: '',
  vendorId: '',
  vendorName: '',
  vendorContactInfo: '',
  estimatedCost: undefined,
  estimatedDuration: '',
  actualDuration: ''
});

export const createDefaultPreventiveMaintenanceRequest = (): PreventiveMaintenanceRequestView => ({
  id: '',
  assetId: '',
  assetTag: '',
  assetName: '',
  category: '',
  instructions: '',
  findings: '',
  partsUsed: '',
  performedBy: '',
  vendorId: '',
});

export const createDefaultCostRecord = (): CostRecordView => ({
  laborCost: undefined,
  partsCost: undefined,
  vendorCost: undefined,
  totalCost: undefined,
  costNotes: '',
});

export const createDefaultCustomApplicationRequest = (): CustomApplicationRequestView => ({
  id: '',
  application: '',
  title: '',
  description: '',
});

export const createDefaultReportingRequest = (): ReportingRequestView => ({
  id: '',
  reportType: '',
  title: '',
  description: '',
});
